import { z } from "zod";

const questionaireAnswersSchema = z.record(z.string(), z.unknown());
const requiredUnknownField = z.unknown().refine((value) => value !== undefined);

export const prospectSchema = z.object({
  submissionId: z.string(),
  submissionTime: z.number(),
  totalScores: z.number(),
  scores: z.record(z.string(), z.number()).optional(),
  projectName: requiredUnknownField,
  projectDeveloper: requiredUnknownField,
  email: requiredUnknownField,
  questionaireAnswers: questionaireAnswersSchema.optional(),
});

export const prospectListSchema = z.array(prospectSchema);

export type ParsedProspect = z.infer<typeof prospectSchema>;

export const parseProspectList = (value: unknown): ParsedProspect[] => {
  return prospectListSchema.parse(value);
};
